import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M 13.4 17 l -8 -8 l 8 -8 h -2.54 l -8 8 l 8 8 h 2.54 z" />
  </svg>
);

export default SvgComponent;
